<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Stock",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "instock",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "buying_p",
          sortable: true,
          label: "BUYING PRICE",
        },
        {
          key: "buying_value",
          sortable: true,
          label: "BUYING PRICE VALUE",
        },
        {
          key: "selling_p",
          sortable: true,
          label: 'SELLING PRICE',
        },
        {
          key: "selling_value",
          sortable: true,
          label: 'SELLING PRICE VALUE',
        }

      ],

      totals: {
        totalInSelling: 0,
        totalInBuying: 0,
      },

      filterProducts: {
        branch_id: 0,
        date: moment(new Date()).format("YYYY-MM-DD"),
        category: ''
      }


    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("products", ["SaveStatus", "FilterStatus", "StockValue", "Categories"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "branchid", "Branches"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StockValue ? this.StockValue.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StockValue ? this.StockValue.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchProducts: "products/fetchStockValue",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchCategories: "products/fetchPCategories",
      FetchBranches: "auth/fetchBranches",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS

    FilterProducts() {
      this.FetchProducts(this.filterProducts);
    },

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        let xx = m.toString().split(".");
        let x1 = xx[0]
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (!xx[1]) {
          if (m.toString().charAt(m.length - 1) == '.') {
            return x1 + ".";

          } else {
            return x1;

          }
        } else {
          return x1 + "." + xx[1];
        }
      } else {
        return m;
      }
    },
    Excel_export() {
      axios
        .post("export_stockvalue", this.filterProducts, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "stockvalue.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },

  },
  created() {
    this.FetchProducts(this.filterProducts);
    this.FetchGeneralSettings();
    this.FetchCategories();
    this.FetchBranches();
  },

  updated() {
    let total_selling = 0;
    let total_buying = 0;
    // let total_paid = 0;
    if (this.StockValue) {
      this.StockValue.forEach((item) => {
        total_buying = total_buying + parseFloat(item.buying_price * item.instock);
        total_selling = total_selling + parseInt(item.selling_price * item.instock);
      });
      this.totals.totalInSelling = parseInt(total_selling);
      this.totals.totalInBuying = total_buying;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9 text-center mb-3">
                <h4 class="card-title">Stock Level with total value</h4>
              </div>
              <div class="col-md-3" align="right">
                <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>SEARCH BY CATEGORY</label>
                <model-list-select :list="Categories ? Categories : []" v-model="filterProducts.category"
                  option-value="id" option-text="catName" placeholder="Select Category" @input="FilterProducts()">
                </model-list-select>
              </div>
              <div class="col-md-4 text-center font-size-15">
                <div class="form-group">
                  <label><b>AS OF {{ filterProducts.date }}</b></label>
                  <input type="date" v-model="filterProducts.date" class="form-control" />
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="FilterProducts()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"><i class="fa fa-file-excel"></i>Export</b-button>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterProducts.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="FilterProducts()">
                </model-list-select>
              </div>
            </div>
            <div class="row py-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="StockValue ? StockValue : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(buying_p)="data">
                  {{ data.item.buying_price ? (data.item.buying_price).toLocaleString() : 0 }}
                </template>
                <template #cell(buying_value)="data">
                  {{ data.item.buying_price ? (data.item.buying_price * data.item.instock).toLocaleString() : 0 }}
                </template>
                <template #cell(selling_p)="data">
                  {{ data.item.selling_price ? (data.item.selling_price).toLocaleString() : 0 }}
                </template>
                <template #cell(selling_value)="data">
                  {{ data.item.selling_price ? (data.item.selling_price * data.item.instock).toLocaleString() : 0 }}
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-6 text-center">
                  <h5>Total Buying Price Value: <span
                      class="text-danger">{{ (totals.totalInBuying).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-6 text-center">
                  <h5>Total Selling Price Value: <span
                      class="text-danger">{{ (totals.totalInSelling).toLocaleString() }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!StockValue" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
